import { NOTIFY_REVIEW_ORDER } from 'redux/modules/order/actions/types';

export const notifyReviewOrder = (): WtrAction => ({
  type: NOTIFY_REVIEW_ORDER,
});
